import { useState, useEffect, Fragment } from 'react';
// import { useTranslation } from 'react-i18next'
import i18next from "i18next";
// import { useNavigate } from "react-router-dom";


import Loader from '../../Loader/Loader';
import { useStore } from '../../../hooks-store/store';
// import { useStore } from '../../../hook-store/store';
import { 
  cardExpire,
  updateSubscriptionDefaultPaymentMethod,
  detachPaymentMethod,
 } from '../../../utils/stripe/payment-method-utils';

import  { BACKEND_URL} from '../../../App';

 import './PaymentMethods.css';
// import classes from './PaymentMethods.module.css';

function PaymentMethodsItem(props) {

  const {
    method,
    subscriptionId,
    isSubscribe,
  } = props;

  // const [t] = useTranslation('translation');

  // const navigate = useNavigate();

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    customerMethods,
    subscriptions,
    // usageBasedValidMethod,
  } = store.stripeData;
  // const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [showConfirmDetach, setShowConfirmDetach] = useState(false);
  
  const updateSubscriptionMethodHandler = async (subscriptionId, paymentMethodId) => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await updateSubscriptionDefaultPaymentMethod(
        BACKEND_URL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
        subscriptionId,
        paymentMethodId,
      );

      // console.log(resData);

      if (resData.data) {

        const updatedSubscriptions = subscriptions.map(subscription => {
          if (subscription.id === resData.data.id) {
            return resData.data;
          } else {
            return subscription;
          }
        });

        dispatch('SET_SUBSCRIPTIONS', updatedSubscriptions);

        // if (isSubscribe) {
        //   navigate("/subscription/account", { 
        //     // state: subscriptionData 
        //   });
        // }
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };



  // const detachMethodHandler = async (paymentMethodId) => {
  //   try {
  //     setIsLoading(true);
  //     // setError('');

  //     const resData = await detachPaymentMethod(
  //       BACKEND_URL, 
  //       localStorage.getItem('token'),
  //       localStorage.getItem('customerId'),
  //       paymentMethodId,
  //     );

  //     // console.log(resData);

  //     if (resData.data) {
  //       const deletedList = customerMethods.filter(method => {
  //         return method.id !== paymentMethodId;
  //       });

  //       dispatch('SET_CUSTOMERMETHODS', deletedList);

  //       if (usageBasedSubscription && 
  //           usageBasedSubscription.default_payment_method === paymentMethodId
  //       ) {
  //           getUsageBasedSubscription();
  //         }
  //     }

  //     setIsLoading(false);

  //   } catch(err) {
  //     console.log(err);
  //     setIsLoading(false);
  //   }
  // };

  // const getUsageBasedSubscription = async () => {
  //   try {
  //     const customerId = localStorage.getItem('customerId');

  //     const resData = await getCustomerSubscriptions(
  //       BACKEND_URL,
  //       localStorage.getItem('token'),
  //       customerId,
  //     )
      
  //     // console.log('usage based subscription', result, resData);
      
  //     if (resData?.data) {
  //       const usageBasedSubscription = resData.data.find(ele => {
  //         return ele.plan.id === usageBasedPrice.id
  //       });
  //       // console.log('usage based subscription', usageBasedSubscription);
  //       if (usageBasedSubscription) {
  //         dispatch('SET_USAGEBASEDSUBSCRIPTION', usageBasedSubscription);
  //       }

  //     }

  //     return resData;

  //   } catch(err) {
  //     console.log(err);
  //     throw err;
  //   }
  // };


  const cardInfo = method.card;
  const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
  
  let isSubscriptionMethod = false;

  const subscription = subscriptions.find(sub => {
    return sub.id === subscriptionId;
  });

  // if (!cardExpired && subscription?.default_payment_method === method.id) {
  //   isSubscriptionMethod = true;
  // }
  if (subscription?.default_payment_method === method.id) {
    isSubscriptionMethod = true;
  }



  let paymentMethodsItemBody

  paymentMethodsItemBody = (
    <div 
    className="paymentMethodsItem"
    >
      {/* {method.id} */}
      <div 
        className="paymentMethodsItemRow"
      >
        {i18next.t('paymentMethod05', 'Card last 4-digit')}:{' '}
        <strong>{cardInfo.last4}</strong>
      </div>
      <div 
      className="paymentMethodsItemRow"
      >
        {i18next.t('paymentMethod06', 'Card expiration date')}:{' '}
        <strong>
          {cardInfo.exp_month}/{cardInfo.exp_year}
        </strong>
      </div>
      <div 
        className="paymentMethodsItemRow"
      >
        ({i18next.t('paymentMethod07', 'add date')} {new Date(method.created*1000).toLocaleDateString()})
      </div>
      {isSubscriptionMethod && (
        <div 
        // className={classes.paymentMethodsItemRow}
        >
          <strong>
            {i18next.t('paymentMethod08', 'Payment method')}
          </strong>
            {/* <button
              disabled={isLoading}
              onClick={() => {
                updateSubscriptionMethodHandler(
                  usageBasedSubscription.id,
                  '',
                );
              }}
            >
            delete-from-sub
          </button> */}
        </div>
      )}
      {!isSubscriptionMethod && !cardExpired && (
        <div 
          className="paymentMethodsItemRow"
        >
          <button className='btnBase'
            disabled={isLoading}
            onClick={() => {
              updateSubscriptionMethodHandler(
                subscriptionId,
                method.id,
              );
            }}
          >
            {i18next.t('paymentMethod09', 'Select this card')}
          </button>
        </div>
      )}
      {cardExpired && (
        <div 
          className="paymentMethodsItemRow"
        >
          {i18next.t('paymentMethod10', 'Expired card')}
        </div>
      )}

      {/* <div>
        <button
          disabled={isLoading}
          onClick={() => {
            setShowConfirmDetach(!showConfirmDetach);
            setSelectedId(method.id);
          }}
        >
          delete-this-method
        </button>
      </div>
      {showConfirmDetach && selectedId === method.id && (
        <div>
          <div>
            delete-this-method?
          </div>
          <button
            disabled={isLoading}
            onClick={() => {
              setShowConfirmDetach(!showConfirmDetach);
            }}
          >
            cancel-detach
          </button>
          <button
            disabled={isLoading}
            onClick={() => {
              detachMethodHandler(method.id);
            }}
          >
            delete-this-method
          </button>
        </div>
      )} */}

      {isLoading && (
        <Loader />
      )}

    </div>
  );



  return (
    <Fragment>
      <div>
        {paymentMethodsItemBody}
      </div>
    </Fragment>
  );
}

export default PaymentMethodsItem;
